var map = {
	"./ar": "d60f",
	"./ar.js": "d60f",
	"./ca": "b6e3",
	"./ca.js": "b6e3",
	"./en": "cda9",
	"./en.js": "cda9",
	"./es": "5038",
	"./es.js": "5038",
	"./locales": "86a7",
	"./locales.js": "86a7",
	"./noHealthPersonnel/en": "91f4",
	"./noHealthPersonnel/en.js": "91f4",
	"./noHealthPersonnel/es": "6749",
	"./noHealthPersonnel/es.js": "6749",
	"./patient/en": "3fed",
	"./patient/en.js": "3fed",
	"./patient/es": "07b6",
	"./patient/es.js": "07b6",
	"./pl": "cf5e",
	"./pl.js": "cf5e",
	"./pt": "4f20",
	"./pt.js": "4f20",
	"./videoconsultation/en": "2022",
	"./videoconsultation/en.js": "2022",
	"./videoconsultation/es": "8791",
	"./videoconsultation/es.js": "8791",
	"./vithas/en": "6c3a",
	"./vithas/en.js": "6c3a",
	"./vithas/es": "c0f3",
	"./vithas/es.js": "c0f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ccbf";